module.exports = __webpack_public_path__ + "static/media/dijon-2.b08a6a4f.jpg";